import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/_shared';
import { CouponDetails, PaymentConfigurationsParams } from '../../components/payment-configurations/payment-configurations.interface';

@Injectable({
  providedIn: 'root'
})
export class PaymentConfigurationsService {

  constructor(
    private http: HttpClient,
    private conf: ConfigurationService
  ) { }

  getStaticData() {
    const url = this.conf.applicationUrls.getPaymentStaticData;
    return this.http.get<PaymentConfigurationsParams>(url);
  }

  setStaticData(data: PaymentConfigurationsParams) {
    const url = this.conf.applicationUrls.getPaymentStaticData;
    return this.http.put<PaymentConfigurationsParams>(url, data);
  }

  getPlanOrderSummary(id) {
    return this.http.get<any>(this.conf.applicationUrls.estimate + id);

  }

  getDiscountedPlanOrderSummary(id, coupon_id) {
    const params = { coupon_ids: [coupon_id] };
    return this.http.get<any>(this.conf.applicationUrls.estimate + id, {
      params: params
    });
  }

  getCouponDetails(couponCode: string) {
    return this.http.get<CouponDetails>(this.conf.applicationUrls.getCouponById + couponCode);
  }

  setRetainMultiplierForAll(retain_multiplier: boolean ) {
    const url = this.conf.applicationUrls.setRetainMultiplier;
    return this.http.put<PaymentConfigurationsParams>(url, { retain_multiplier: JSON.stringify(retain_multiplier) });
  }
}
